import React, { createContext, useContext, useMemo, useState } from 'react';
import { ADMIN_SIDEBAR, USER_SIDEBAR } from '../../constant';
import useUser from '../../Hooks/useUser';

const NavigationContext = createContext({
  currentPage: '',
  setCurrentPage: () => {
    /* do nothing */
  },
  sidebarNavigation: null,
  setSidebarNavigation: () => {
    /* do nothing */
  }
});

export const NavigationContextProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState('home');
  const [sidebarNavigation, setSidebarNavigation] = useState(null);
  const { currentUser, userView } = useUser();
  const [forceCollapse, setForceCollapse] = useState(false);

  useMemo(() => {
    return currentUser?.role === 'admin' && !userView
      ? setSidebarNavigation(ADMIN_SIDEBAR)
      : setSidebarNavigation(USER_SIDEBAR);
  }, [currentUser?.role, userView]);

  return (
    <NavigationContext.Provider
      value={{ currentPage, setCurrentPage, sidebarNavigation, setSidebarNavigation, forceCollapse, setForceCollapse }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNav = () => useContext(NavigationContext);
